import { Route, Routes } from "react-router-dom";
import AppsError from "./apps-error";
import Event from "./event";

const EventRouter = () => {
  return (
    <Routes>
      <Route path="/:id" element={<Event />} />
      <Route path="/" element={<AppsError />} />
    </Routes>
  );
};

export default EventRouter;
